import ActiveFilters from '../components/filtercomponents/activefilters';
import RadioInput from '../components/filtercomponents/radioinput';
import CheckboxInput from '../components/filtercomponents/checkboxinput';
import $ from 'jquery';
const CLASSES = {
    active: 'active',
    expanded: 'expanded',
    entered: 'input--entered'
};

class Filters {
    constructor(el) {
        this.renderedFilters = [];
        this.el = el;
        this.gatherFilterelements();
        this._setupEvents();

        this.filterFooter = new ActiveFilters(this.filterSelectedBoxEl, {
            onFilterRemove: this._onFilterRemove.bind(this),
            onClearAll: this.submitForm.bind(this)
        });
        this.filterSettingsEl.each((index, element) => {
            this.renderFilter(this._getFilterSettings($(element)));
        });
        const displayOnLoad = this.el.data('filter-display-on-load');
        if (this.renderFilter.length && displayOnLoad) {
            this.renderedFilters[0].show();
        }
    }
    gatherFilterelements() {
        this.groupsEl = this.el.find('.filters__groups');
        this.dropdownContainerEl = this.el.find('.filters__dropdown__container');
        this.filterSettingsEl = this.el.find('.filters__filter');
        this.selectedMobileEl = this.el.find('.filters__filter__selected');
        this.selectedItemsEl = this.el.find('.filters__selected__items');
        this.filterSelectedBoxEl = this.el.find('.filters__selected');
    }

    _setupEvents() {
        this.groupsEl.on('click', '.filters__filter__title', this._filterSelectedHandler.bind(this));
        this.selectedMobileEl.on('click', () => { this.filterSettingsEl.toggleClass(CLASSES.expanded); });

    }
    _filterSelectedHandler(e) {
        const filterEl = $(e.target).parents('.filters__filter');
        const renderedFilter = this._getAssociatedFilter(filterEl);
        if (filterEl.hasClass('active')) {
            filterEl.removeClass('active');
            renderedFilter.hide();
        }
        else {
            filterEl.addClass('active');
            const siblings = filterEl.siblings();
            siblings.removeClass('active');
            this.renderedFilters.forEach(t => t.hide());
            renderedFilter.show();
        }
        this.selectedMobileEl.text(filterEl.text());
        this.filterSettingsEl.removeClass(CLASSES.expanded);
    }
    _getAssociatedFilter(filterElement) {
        const fieldName = filterElement.data('filter-field-name') || '';
        return this.renderedFilters.find(rf => rf.name === fieldName);
    }

    _getFilterSettings(filterElement) {
        const fieldName = filterElement.data('filter-field-name') || '';
        const filterLegend = filterElement.data('filter-legend') || '';
        const options = filterElement.data('filter-options') || {};
        const type = filterElement.data('filter-type') || 'checkbox';
        const initialSelection = filterElement.data('filter-initial-selection');
        const autoApply = filterElement.data('filter-autoapply') === true;
        return {
            filterElement,
            fieldName,
            options,
            type,
            autoApply,
            initialSelection,
            filterLegend
        };
    }
    submitForm() {
        this.dropdownContainerEl.closest('form').submit();
    }
    renderFilter(filterSettings) {
        const { fieldName, options, type, initialSelection, autoApply, filterLegend } = filterSettings;
        if (type === 'radio') {
            const radioOptions = {
                fieldName: fieldName,
                options: options,
                filterLegend: filterLegend,
                initialSelection: initialSelection,
                showApplyButton: autoApply,
                onChangeEvent: (function (currentValue) {
                    if (currentValue) {
                        if (autoApply) {
                            this.submitForm();
                            return;
                        }
                        this.filterFooter.addFilter({
                            name: fieldName,
                            label: currentValue.label,
                            value: currentValue.value,
                            inputEl: currentValue.inputEl,
                            radio: currentValue.radio
                        }, false);
                    }
                    else {
                        this.filterFooter.removeFilterByName(fieldName);
                    }
                }).bind(this),
            };
            const radio = new RadioInput(this.dropdownContainerEl, radioOptions);
            this.renderedFilters.push(radio);
            const el = radio.getInputElFromValue(initialSelection);
            if (initialSelection) {
                this.filterFooter.addFilter({
                    type: 'radio',
                    name: fieldName,
                    label: options[initialSelection],
                    value: initialSelection,
                    inputEl: $(el),
                    radio: radio
                }, false);
            }

        }
        else {
            const checkbox = new CheckboxInput(this.dropdownContainerEl,
                {
                    fieldName: fieldName,
                    filterLegend: filterLegend,
                    options: options,
                    initialSelection: initialSelection,
                    onChangeEvent: (function (selectedItem) {
                        if (selectedItem.selected) {
                            this.filterFooter.addFilter({
                                type: 'checkbox',
                                name: fieldName,
                                label: selectedItem.label,
                                value: selectedItem.value,
                                inputEl: selectedItem.inputEl,
                                checkbox: selectedItem.checkbox
                            }, true);
                        }
                        else {
                            this.filterFooter.removeFilterByValue(selectedItem.value);
                        }
                    }).bind(this)
                });
            this.renderedFilters.push(checkbox);
            if (initialSelection) {
                initialSelection.forEach(selection => {
                    if (options[selection]) {
                        const el = checkbox.getInputElFromValue(selection);
                        this.filterFooter.addFilter({
                            type: 'checkbox',
                            name: fieldName,
                            label: options[selection],
                            value: selection,
                            inputEl: $(el),
                            checkbox: checkbox
                        }, true);


                    }
                });
            }
        }
    }
    _onFilterRemove(filters) {
        filters.forEach(el => {
            var inputElement = $(el.inputEl);
            switch (el.type) {
            case 'checkbox':
                el.checkbox.unselect(inputElement);
                break;
            case 'radio':
                el.radio.unselect(inputElement);
                break;
            default:
                inputElement.val('');
                break;
            }
        });

    }
}
export default Filters;